import React from 'react';

import { Divider } from '@material-ui/core';
import PropTypes from 'prop-types';

const baseStyles = {
  header: {
    width: '95vw',
    marginRight: '2rem',
    marginLeft: '1.5rem',
  },
};

const AdminHeader = (props) => {
  return (
    <div style={baseStyles.header}>
      <h1>{props.header}</h1>
      <Divider />
    </div>
  );
};

AdminHeader.defaultProps = {
  header: 'Patients',
};

AdminHeader.propTypes = {
  header: PropTypes.string,
};

export default AdminHeader;
